export default __webpack_public_path__ + "static/loading-screen-bg-a0bf16b4e40e4e1f8d84f34821aa83d4.jpg";